<template>
  <div class="my-banner">
    <el-carousel>
      <el-carousel-item >
        <img  class="img-item" src="../../assets/image/banner/carousel/1煤炭.jpg" alt="" />
      </el-carousel-item>
      <el-carousel-item >
        <img  class="img-item" src="../../assets/image/banner/carousel/2电力.jpg" alt="" />
      </el-carousel-item>
      <el-carousel-item >
        <img  class="img-item" src="../../assets/image/banner/carousel/3化工.jpg" alt="" />
      </el-carousel-item>
      <el-carousel-item >
        <img  class="img-item" src="../../assets/image/banner/carousel/4物流.jpg" alt="" />
      </el-carousel-item>
      <el-carousel-item >
        <img  class="img-item" src="../../assets/image/banner/carousel/5新能源.jpg" alt="" />
      </el-carousel-item>
    </el-carousel>

  </div>
</template>

<script>
export default {
  name: 'banner',
}
</script>

<style scoped lang="scss">

.my-banner {
  height: 320px;
  background: transparent;
  z-index: 21;
}

::v-deep {
  .el-carousel {
  }

  .el-carousel .img-item {
    display: block;
    height: 320px;
    width: 100%;
  }

  .el-carousel__item {
  }

  .el-carousel .el-carousel__container {
    height: 320px;
  }
}


.my-banner {

  ::v-deep {

    .el-carousel__button {
      width: 12px;
    }

  }

}


@media screen and (min-width: 320px) { 

}

@media screen and (min-width: 480px) { 
    
}
/* 移动 */
@media screen and (min-width: 576px) { 
    .banner {
    width: 100%;
    display: inline-block;
    overflow: hidden;
    z-index: 0;
    height: 230px;
  }
  .imag {
    display: block;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
}
/* 平板 */
@media screen and (min-width: 768px) { 

  .my-banner {

    ::v-deep {

      .el-carousel__button {
        width: 30px;
      }

    }

  }

}

/* PC */
@media screen and (min-width: 992px) {

}
@media screen and (min-width: 1200px) {

  .my-banner {
    margin-left: 24px;
    margin-right: 24px;
  }

}



</style>
